export const GET_SUBSCRIPTION_FEATURES_DATA = "GET_SUBSCRIPTION_FEATURES_DATA";
export const UPDATE_SUBSCRIPTION_FEATURES_DATA = "UPDATE_SUBSCRIPTION_FEATURES_DATA";